import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../interfaces/marker';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { Message, FileUpload } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { WorkExperienceService } from '../../../employee/service/work-experience/work-experience.service';
import { calendarES } from '../../../../theme/functions/calendarES';
import { formatDate } from '../../../../theme/functions/formatDate.function';

@Component({
  selector: 'app-candidate-work-experiences',
  templateUrl: './candidate-work-experiences.component.html',
  styleUrls: ['./candidate-work-experiences.component.scss']
})
export class CandidateWorkExperiencesComponent implements OnInit {
  @Input() index: number;
  @Input() candidate_id: number;
  @Input() work_candidate: any;
  @Output() work_output: EventEmitter<any> = new EventEmitter<any>();
  @Output() add_work_output: EventEmitter<any> = new EventEmitter<any>();

  public apiUrl = config.API_ROOT;
  public loading_upload: boolean = false;
  public promiseForm: Promise<any>;
  public msgs: Message[];
  
  public form: FormGroup;

  public es: any;

  constructor(
    public fb: FormBuilder,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    public workExperienceService: WorkExperienceService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    private ngZone: NgZone
  ) {
    this.es = calendarES();
  }

  ngOnInit() {
    this.createForm(this.work_candidate);
  }

  ngOnChanges(changes: SimpleChanges): void {
    /* if(this.form.get('present').value == false) {
      this.form.get('end').setValidators([ Validators.required ]);
      this.form.get('end').updateValueAndValidity();
    } */
  }

  createForm(data:any=null) {
    data = data || {
      id : null,
      company: null,
      employee_position: null,
      start: null,
      end: null,
      present: false,
      contact_name : null,
      contact_phone: null,
      job_functions: null,
    };

    this.form = this.fb.group({
      id: new FormControl( data.id ),
      company: new FormControl( data.company, Validators.compose([ Validators.required, Validators.minLength(3) ]) ),
      employee_position: new FormControl( data.employee_position, Validators.compose([ Validators.required, Validators.minLength(5) ]) ),
      start: new FormControl( data.start ? new Date(data.start): null, Validators.compose([ Validators.required ]) ),
      end: new FormControl( data.end ? new Date(data.end): null ),
      present: new FormControl( data.present ),
      contact_name : new FormControl(data.contact_name, Validators.compose([ Validators.minLength(3) ])),
      contact_phone : new FormControl(data.contact_phone, Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ])),
      job_functions: new FormControl( data.job_functions, Validators.compose([ Validators.required, Validators.minLength(10), Validators.maxLength(1500) ]) ),
    });
  }

  public addCandidateWorkExperience(values) {
    this.loading_upload = true;
    values['index'] = this.index;
    values['candidate_id'] = this.candidate_id;
    values['experience_structure'] = 1;

    if(values.start != null && values.start != '' && values.start != undefined)
      values.start = formatDate(values.start);

    if(values.present == false) {
      if(values.end != null && values.end != '' && values.end != undefined)
        values.end = formatDate(values.end);
    } else
      values.end = null;

    const promise = (values.id) ? this.workExperienceService.updateWorkExperience(values.id, values) : this.workExperienceService.addWorkExperience(values);
    this.promiseForm = promise.toPromise().then(
      response => {
        this.loading_upload = false;
        let resp_contact= response.json();
        resp_contact['index'] = this.index;
        this.add_work_output.emit(resp_contact);
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
      },
      error => {
        this.loading_upload = false;
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public deleteCandidateWorkExperience(work_candidate) {
    this.loading_upload = true;
    work_candidate['index'] = this.index;
    this.work_output.emit(work_candidate);

    if(work_candidate.id != undefined) {
      const promise = this.workExperienceService.deleteWorkExperience(work_candidate.id);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('deleted').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
          });
        },
        error => {
          let msg = '';
          this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
            this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
              JSON.parse(error._body).errors.forEach(element => {
                if (element.source) {
                  if (element.source.pointer) {
                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                      msg = msg + res3 + ', ';
                    });
                  }
                }
              });
              this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
            });
          });
        }
      );
    }
  }

  getRequiredDataEnd(formData) {
    if (formData == null || formData == '' || formData == undefined) {
      formData = false;
      this.form.get('present').setValue(false);
    }

    if(formData == false)
      this.form.get('end').setValidators([ Validators.required ]);
    else
      this.form.get('end').setValidators([ ]);
    
    this.form.get('end').updateValueAndValidity();

    return formData;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/candidate-work-experiences/candidate-work-experiences.component.ts